import React, { useEffect, useState, Fragment } from "react";
import { Link } from "react-router-dom";

import LoadingSpinner from "./LoadingSpinner";
import Button from "./Button";
import ProjectForm from "./ProjectForm";
import useProjects from "../hooks/useProjects";
import {
  AdminGrid,
  AdminGridCell,
  AdminGridHeading,
  AdminGridHeader,
} from "./AdminGrid";
import IconButton from "./IconButton";
import { Order_By, Project_Order_By } from "@/graphql/generated/graphql";

const defaultOrder = [{ name: Order_By.Asc }];

const headings: AdminGridHeading<Project_Order_By>[] = [
  {
    label: "Name",
    order: {
      asc: [{ name: Order_By.Asc }],
      desc: [{ name: Order_By.Desc }],
    },
  },
  {
    label: "Programme",
    order: {
      asc: [{ programme: { name: Order_By.Asc } }, ...defaultOrder],
      desc: [{ programme: { name: Order_By.Desc } }, ...defaultOrder],
    },
  },
  {
    label: "",
  },
];
const ManagerProjects: React.FC = () => {
  const [orderBy, setOrderBy] = useState<Project_Order_By[]>(defaultOrder);

  const { projects, error, loading, refetch } = useProjects({
    orderBy,
  });
  useEffect(() => {
    refetch();
  }, []);

  return (
    <div>
      <header className="flex justify-between items-center mb3">
        <h1>Projects </h1>
        <ProjectForm
          onClose={refetch}
          Opener={(props) => (
            <Button {...props} raised fill>
              New project
            </Button>
          )}
        />
      </header>
      <AdminGrid columns={headings.length}>
        <AdminGridHeader
          orderBy={orderBy}
          setOrderBy={setOrderBy}
          headings={headings}
        />
        {projects.map((project) => {
          const { id, name, programme } = project;

          return (
            <Fragment key={`ManagerProjects-li-${id}`}>
              <AdminGridCell>{name}</AdminGridCell>
              <AdminGridCell>{programme.name}</AdminGridCell>
              <AdminGridCell justify="flex-end">
                <ProjectForm
                  onClose={refetch}
                  initialValues={project}
                  Opener={(props) => <IconButton icon="edit" {...props} />}
                />
              </AdminGridCell>
            </Fragment>
          );
        })}
      </AdminGrid>
      {loading && <LoadingSpinner type="row" />}
      {error && <p>{error.message}</p>}
    </div>
  );
};

export default ManagerProjects;
